"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReadyState = exports.isSDKEventMessage = exports.SDKEvent = void 0;
/**
 * SDK 相关的事件，和编辑器无关
 */
exports.SDKEvent = Object.freeze({
    /**
     * 一般指 container viewport 发生变化时触发，比如窗口大小变化。会优先使用 window.visualViewport resize 事件，不可用时使用 window.resize 事件。
     */
    ViewportResize: 'ViewportResize',
    /**
     * SDK 和编辑器初始化状态
     */
    ReadyState: 'ReadyState',
});
/**
 * 判断是否是 SDKEvent 事件消息
 */
function isSDKEventMessage(input) {
    var event;
    if (input != null) {
        event = input.event;
    }
    return typeof event === 'string' && event in exports.SDKEvent;
}
exports.isSDKEventMessage = isSDKEventMessage;
/**
 * SDK 和编辑器初始化状态
 */
var ReadyState;
(function (ReadyState) {
    /**
     * 正在初始化 SDK
     */
    ReadyState["Loading"] = "loading";
    /**
     * 正在初始化编辑器
     */
    ReadyState["LoadingEditor"] = "loadingEditor";
    /**
     * SDK 和编辑器初始化完成，因编辑器含异步组件，因此仅代表可以和编辑器交互，不代表编辑器完成全部加载。
     */
    ReadyState["Ready"] = "ready";
    /**
     * 初始化失败
     */
    ReadyState["Failed"] = "failed";
    /**
     * 已经被销毁
     */
    ReadyState["Disconnected"] = "disconnected";
})(ReadyState = exports.ReadyState || (exports.ReadyState = {}));
